import _ from 'lodash';
import { isObject } from '@skyjs/lodash-extras';

export default function makeGetPathExpression(operatorExpressions, options = {}) {
  return function getPathExpression(value, key, rootCriteria, path = [], isNegated = false) {
    if (_.isString(value)) {
      value = _.trim(value);
    } else if (isDateLike(value) && options.convertDateToString) {
      value = value.toISO();
    } else if (value === false && key === 'equal') {
      if (!isNegated) {
        const clause = {
          $or: [{ [path.join('.')]: { $eq: false } }, { [path.join('.')]: { $eq: null } }]
        };

        return path.length > 1
          ? [{ [_.take(path, path.length - 1).join('.')]: { $exists: true } }, clause]
          : clause;
      }
    } else if ((value === null || isEmptyArray(value)) && key === 'equal') {
      key = 'in';
      value = [null, []];
    } else if ((value === null || isEmptyArray(value)) && key === 'notEqual') {
      key = 'notIn';
      value = [null, []];
    } else if (['in', 'notIn'].includes(key) && value === null) {
      value = [];
    }

    if (['in', 'notIn'].includes(key) && !_.isArray(value)) {
      value = [value];
    }

    const isNot = _.keys(value).length === 1 && _.keys(value)[0] === 'not';

    if (isNot) {
      value = value.not;
    }

    const queryExpression = _.has(operatorExpressions, key) ? operatorExpressions[key] : null;
    if (queryExpression) {
      if (_.isObject(value) && !isDateLike(value) && !_.isArray(value) && key !== 'itemMatch') {
        return _.map(value, (subValue, subKey) => {
          assertIsFieldPath(subKey);
          return queryExpression.getPathExpression([path, subKey], subValue, isNegated || isNot);
        });
      } else {
        return queryExpression.getPathExpression(path, value, isNegated || isNot);
      }
    }

    assertIsFieldPath(key);

    let result;

    if (isObject(value) && !isDateLike(value)) {
      result = _.map(value, (subValue, subKey) =>
        getPathExpression(subValue, subKey, rootCriteria, [...path, key], isNegated || isNot)
      );
    } else {
      const defaultKey = _.isArray(value) && !_.isEmpty(value) ? 'in' : 'equal';
      result = getPathExpression(
        value,
        defaultKey,
        rootCriteria,
        [...path, key],
        isNegated || isNot
      );
    }

    return result;
  };
}

// Une clé qui n'est pas un opérateur connu devient un chemin de champ : un segment commençant par
// `$` en ferait un opérateur MongoDB ($expr, $where…) choisi par l'appelant. containsWords sépare
// ses champs par des virgules, d'où le découpage sur `,` en plus de `.`.
function assertIsFieldPath(key) {
  const segments = String(key).split(/[.,]/);
  if (segments.some(segment => _.trim(segment).startsWith('$'))) {
    throw new Error(`Invalid criteria key: ${key}`);
  }
}

const isEmptyArray = value => _.isArray(value) && _.isEmpty(value);
const isDateLike = value => isObject(value) && _.isFunction(value.toISO);
